module.exports = __webpack_public_path__ + "img/7.23791086.png";